import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { ISeoMetaData } from 'data/seo'
import { useLocation } from 'react-router-dom'
import { seoObjectLookup } from 'utils/seo-helper'
import { useSelector } from 'react-redux'
import {
  getLanguage
} from 'redux/reducers/users'
import { Tealium } from 'components/Tealium/Tealium'
import { getUtagSyncUrl, getUtagUrl } from 'utils/urls/tealiumUrls'

export interface SEOProps {
  seoMetaData: ISeoMetaData[];
}

export const SEO: React.FC<SEOProps> = ({ seoMetaData }) => {
  const location = useLocation()
  const [foundSeoObject, setFoundSeoObject] = useState<ISeoMetaData>()
  const [loaded, setLoaded] = useState(false)
  const [isNoTranslate, setIsNoTranslate] = useState<boolean>(false)
  const language = useSelector(getLanguage)

  useEffect(() => {
    // SEO DATA
    const currentPathName = location.pathname.toLowerCase().replace(/\/$/, '') // remove any ending "/" characters
    const tempFoundSeoObject = seoObjectLookup(seoMetaData, currentPathName)

    // QM MASKING
    if (tempFoundSeoObject?.isQmMaskingEnabled) {
      document.body.classList.add('qm-allow-specific-masking')
    } else {
      document.body.classList.remove('qm-allow-specific-masking')
    }

    // STATE UPDATES
    setFoundSeoObject(tempFoundSeoObject)
    setLoaded(true)
  }, [location, seoMetaData])

  const { title, description } = (language && foundSeoObject) ? foundSeoObject.seo[language] : { title: null, description: null }
  const blastPageName = foundSeoObject?.blastPageName

  // update document title immediately since react helmet is not immediate
  if (title && document.title !== title) {
    document.title = title
  }

  const utagUrl = useMemo(getUtagUrl, [getUtagUrl])
  const utagSyncUrl = useMemo(getUtagSyncUrl, [getUtagSyncUrl])
  useEffect(() => {
    window.utag_cfg_ovrd = { noview: true }
  }, [])

  useEffect(() => {
    if (window.location.pathname.includes('/get-my-medicare-card')) {
      setIsNoTranslate(true)
    }
  }, [location])

  return (
    <>
      {loaded && <Tealium blastPageName={blastPageName} />}
      <Helmet>
        <html lang={language} />
        <title>{title || 'Medicare.gov/my'}</title>
        <meta property='og:title' content={title || 'Medicare.gov/my'} />
        {isNoTranslate && <meta name="google" content="notranslate"/>}
        <meta property='og:description' content={description || 'Medicare.gov website'} />
        <script src={utagUrl} type='text/javascript' />
        <script src={utagSyncUrl} type='text/javascript' />
      </Helmet>
    </>
  )
}
